import type { App } from 'vue'
import { ApiClientInjectionKey } from './useApiClient.ts'
import { createClient } from '@hey-api/client-fetch'
import { isDefined } from '@vueuse/core'

export function ApiClientPlugin(app: App<unknown>, options: { baseUrl: string }) {
  app.provide(ApiClientInjectionKey, (accessToken: string | null) => {
    return createClient({
      baseUrl: options.baseUrl,
      headers: isDefined(accessToken)
        ? {
            Authorization: `Bearer ${accessToken}`,
          }
        : undefined,
    })
  })
}
